import { graphql } from "gql/apollo";

export const DeleteIntegration = graphql(/* GraphQL */ `
	mutation DeleteGenetecIntegrationByGID(
		$params: DeleteGenetecIntegrationByGIDParams!
	) {
		deleteGenetecIntegrationByGID(params: $params) {
			error {
				message
			}
			success
		}
	}
`);
